import { CForm, CSpinner } from '@coreui/react-pro'
import axios from 'axios'
import { Disclosure, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import { useContext, useEffect, useState } from 'react'
import Avatar from 'react-avatar'
import { FaUpload } from 'react-icons/fa'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AppHeader } from 'src/business/components'
import countryAndCode from 'src/business/countries/countryList'
import { getCustomerDetails } from 'src/business/services/APIs/Customer/CustomerDetails'
import {
  getPersonalDetails,
  updatePersonalDetails,
} from 'src/business/services/APIs/Customer/PersonalDetails'
import {
  businessApiURL,
  getCountryCode,
  getLanguageCode,
  getToken,
} from 'src/business/services'
import { commonHeadersWeb } from 'src/consumer/services'
import {
  updateBillingDetails,
  updateCompany,
  updateCustomer,
} from 'src/business/services/APIs/Customer/UpdateCustomer'
import { CHeading3 } from 'src/components/coreUIMimicComponent'
import { ThemeContext } from 'src/context/ThemeContext'
import './form.css'
import arrow from './right-arrow.png'
import { Row } from 'react-bootstrap'

const UserProfile = ({ heading }) => {
  const [password, setNewPassword] = useState('')
  const [items, setItems] = useState([])
  const [newCompany, setNewCompany] = useState('')
  const [customer, setCustomer] = useState([
    {
      primaryContact: '',
    },
  ])
  const [billing, setBilling] = useState([])
  const [billingEmail, setBillingEmail] = useState('')
  const [billingName, setBillingName] = useState('')
  const [vat, setVat] = useState('')
  const [oldPassword, setoldPassword] = useState('')
  const [confPassword, setConfPassword] = useState('')
  const [department, setDepartment] = useState('')
  const [designation, setDesignation] = useState('')
  const [officeLocation, setOfficeLocation] = useState('')
  const [loading, setLoading] = useState(false)
  const [passwordType, setPasswordType] = useState('password')
  const [newPasswordType, setNewPasswordType] = useState('password')
  const [primary, setPrimary] = useState([])
  const [name, setName] = useState('')
  const [edit, setEdit] = useState(false)
  const [uploadingPicture, setUploadingPicture] = useState(false)
  const [tempImgUrl, setTempImgUrl] = useState(null)
  const { theme } = useContext(ThemeContext)

  const handleFileUpload = async (event) => {
    const file = event?.target?.files?.[0]
    if (!file) return
    if (!file.type.startsWith('image/')) {
      toast.error('Please select an image file')
      event.target.value = ''
      return
    }

    const reader = new FileReader()
    reader.onload = () => setTempImgUrl(reader.result)
    reader.readAsDataURL(file)

    const formData = new FormData()
    formData.append('file', file)
    setUploadingPicture(true)

    try {
      const uploadResponse = await axios.post(
        `${businessApiURL}/api/media/file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': getLanguageCode(),
          },
        },
      )

      if (uploadResponse?.status === 200 && uploadResponse?.data?.fileId) {
        const updateResponse = await updatePersonalDetails({
          profilePicId: uploadResponse.data.fileId,
          designation,
          department,
          officeLocation,
          firstName: name,
        })

        if (updateResponse?.status === 200) {
          setTempImgUrl(null)
          toast.success('Profile picture updated successfully')
          await userData()
        } else {
          setTempImgUrl(null)
          toast.error('Failed to update profile')
        }
      } else {
        setTempImgUrl(null)
        toast.error('Failed to upload image')
      }
    } catch (error) {
      console.error('Profile picture upload error:', error)
      setTempImgUrl(null)
      toast.error('Something went wrong. Please try again.')
    } finally {
      setUploadingPicture(false)
      event.target.value = ''
    }
  }

  const update = async () => {
    setLoading(true)
    const response = await updateCustomer(primary)
    console.log(response)
    setEdit(!edit)
    await userData()
    await details()
    setLoading(false)
    toast.success('Locations Updated Successfully')
  }

  const updateCompanyName = async () => {
    setLoading(true)
    const response = await updateCompany(newCompany)
    sessionStorage.setItem('companyName', newCompany)
    console.log(response)
    setEdit(!edit)
    setLoading(false)
    toast.success('Company Name Updated Successfully')
  }

  const updatePersonal = async () => {
    setLoading(true)
    const response = await updatePersonalDetails({
      designation: designation,
      department: department,
      officeLocation: officeLocation,
      firstName: name,
    })
    await userData()
    await details()
    console.log(response)
    setLoading(false)
    toast.success('Details Updated Successfully')
  }

  const updateBilling = async () => {
    setLoading(true)
    const response = await updateBillingDetails(billingName, billingEmail, vat)
    console.log(response)
    setEdit(!edit)
    await userData()
    await details()
    setLoading(false)
    toast.success('Billing Details Updated Successfully')
  }

  const userData = async () => {
    setLoading(true)
    const response = await getPersonalDetails()
    setItems(response.data)
    setOfficeLocation(response.data.officeLocation)
    setDesignation(response.data.designation)
    setDepartment(response.data.department)
    setName(response.data.name)
    setLoading(false)
  }

  const details = async () => {
    setLoading(true)
    const response = await getCustomerDetails()
    setCustomer(response.data || [{}])
    setPrimary(response.data.locations || [])
    setLoading(false)
    setBilling(response.data.billingDetails || [])
    setBillingName(response.data.billingDetails.attnName)
    setBillingEmail(response.data.billingDetails.attnEmailId)
    setVat(response.data.billingDetails.vatNumber)
  }

  useEffect(() => {
    userData()
    setNewCompany(sessionStorage.getItem('companyName'))
    details()
  }, [])

  let handleChange = (i, e) => {
    let newPrimary = [...primary]
    newPrimary[i][e.target.name] = e.target.value
    setPrimary(newPrimary)
  }

  function handleCountryCode(index, element) {
    let countryDict = countryAndCode.find(
      (keyValue) => keyValue.name.common === element.target.value,
    )
    let elementClone = {
      target: {
        name: 'countryCode',
        value: countryDict.countryCode.toLowerCase(),
      },
    }
    handleChange(index, elementClone)
  }

  let addFormFields = () => {
    setPrimary([
      {
        address: '',
        country: '',
        countryCode: '',
        state: '',
        pincode: '',
        city: '',
      },
      ...primary,
    ])
  }

  function findCountry(code) {
    let country = countryAndCode.filter(function (obj) {
      return obj.countryCode === code
    })
    return country.countryCode
  }

  let removeFormFields = (i) => {
    let newPrimary = [...primary]
    newPrimary.splice(i, 1)
    setPrimary(newPrimary)
  }
  let handleSubmit = (event) => {
    event.preventDefault()
    setEdit(!edit)
    if (edit === false) {
      document.getElementById('editButton').innerHTML = 'Save'
    } else {
      document.getElementById('editButton').innerHTML = 'Edit'
    }
  }
  const togglePassword = () => {
    if (passwordType === 'password') {
      setPasswordType('text')
      return
    }
    setPasswordType('password')
  }
  const toggleNewPassword = () => {
    if (newPasswordType === 'password') {
      setNewPasswordType('text')
      return
    }
    setNewPasswordType('password')
  }

  const PasswordChange = async (e) => {
    setLoading(true)
    e.preventDefault()
    const token = localStorage.getItem('token')
    var myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
    }

    if (password === confPassword && password !== oldPassword) {
      fetch(
        `https://manage.aumhum.com/api/secure/user/password/change?oldPassword=${oldPassword}&password=${password}`,
        requestOptions,
      )
        .then((res) => {
          if (res.status === 200) {
            toast.success('Password changed')
          } else {
            toast.error('Something went wrong')
          }
        })
        .catch((error) => {
          toast.error(error)
        })
    } else {
      toast.error('Passwords not matching')
    }
    setLoading(false)
    setoldPassword('')
    setNewPassword('')
    setConfPassword('')
  }
  return (
    <>
      <AppHeader heading={'Profile'} />
      <div>
        {loading ? (
          <CSpinner className={loading ? `block p-4 m-4` : `hidden`} />
        ) : (
          <>
            <div id="personal-details" style={{ width: '100%', padding: '1.5rem', alignItems: 'justify' }}>
              <div className="mb-4"  >
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <>
                      <Disclosure.Button style={{ backgroundColor: '#EBF1FF', display: 'flex', alignItems: 'justify', padding: '24px', borderRadius: '0.5rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', width: '100%', border: 'none' }}>
                        <CHeading3 style={{ color: '#5B38A8', flex: '1', display: 'flex' }}>
                          Personal Details
                        </CHeading3>
                        <ChevronDownIcon
                          className="bi bi-chevron-up" style={{ transform: open ? 'rotate(180deg)' : 'none', color: '#5B38A8', height: '40px', width: '40px' }}
                        />
                      </Disclosure.Button>
                      <Transition
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                      >
                        <Disclosure.Panel className="">
                          <div style={{ backgroundColor: '#EBF1FF', darkBackgroundColor: '#1F2937', padding: '1.5rem', borderBottomLeftRadius: '1rem', marginTop: '-0.25rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
                            {loading ? (
                              <CSpinner className={loading ? `p-block p-4 m-4` : `hidden`} />
                            ) : (
                              <div className='d-flex flex-column-reverse flex-md-row'>
                                <CForm className='w-100 w-md-60' style={{ width: '60%', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                                  <div style={{ width: '100%', position: 'relative' }}>

                                    <input
                                      id="name"

                                      type="text"
                                      style={{
                                        borderColor: '#8496FF',
                                        backgroundColor: 'transparent',
                                        borderWidth: '2px',
                                        border: '2px solid #8496FF',
                                        width: '100%',
                                        padding: '0.75rem',
                                        outline: 'none',

                                        borderRadius: '0.5rem'
                                      }}
                                      value={name}

                                      onChange={(event) => {
                                        setName(event.target.value)
                                      }}
                                    />
                                    <label htmlFor="Name" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem' }}>
                                      Name
                                    </label>


                                  </div>

                                  <div  className='d-flex w-100 flex-column gap-3 flex-md-row'>
                                    <div  className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                      <input
                                        id="email"
                                        type="email"
                                        style={{
                                          borderColor: '#8496FF',
                                          backgroundColor: 'transparent',
                                          borderWidth: '2px',
                                          width: '100%',
                                          padding: '0.75rem',
                                          outline: 'none',
                                          borderRadius: '0.5rem',
                                          border: '2px solid #8496FF'

                                        }}

                                        defaultValue={customer.primaryContact}
                                        readOnly
                                      />
                                      <label htmlFor="Email" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem' }}>
                                        Email
                                      </label>
                                    </div>

                                    <div  className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                      <select
                                        id="officeLocation"
                                        style={{
                                          borderColor: '#8496FF',
                                          borderRadius: '0.5rem',
                                          padding: '0.75rem',
                                          borderWidth: '2px',
                                          outline: 'none',
                                          backgroundColor: 'transparent',
                                          width: '100%',
                                          border: '2px solid #8496FF'
                                        }}
                                        value={officeLocation}
                                        onChange={(e) => setOfficeLocation(e.target.value)}
                                      >
                                        {countryAndCode
                                          .sort((a, b) =>
                                            a.name.common.localeCompare(b.name.common),
                                          )
                                          .map((country, index) => (
                                            <option
                                              key={index}
                                              className="text-black"
                                              style={{
                                                backgroundColor: '#C5CEFD',
                                              }}
                                              value={country.name.common}
                                            >
                                              {country.name.common}
                                            </option>
                                          ))}
                                      </select>
                                      <label htmlFor="officeLocation" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem' }}>
                                        Country
                                      </label>
                                    </div>
                                  </div>

                                  <div className='d-flex w-100 flex-column gap-3 flex-md-row'>
                                    <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                      <input
                                        id="designation"
                                        type="text"
                                        style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                        // className="bg-transparent border-2 w-full p-3 outline-none rounded-lg dark:text-white"
                                        onChange={(e) => setDesignation(e.target.value)}
                                        value={designation}
                                      />
                                      <label htmlFor="Designation" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem' }}>
                                        Designation
                                      </label>
                                    </div>

                                    
                                      <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                        <input
                                          id="Department"
                                          type="text"
                                          style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                          // className="bg-transparent border-2 w-full p-3 outline-none rounded-lg dark:text-white"
                                          onChange={(e) => setDepartment(e.target.value)}
                                          defaultValue={department}
                                        />
                                        <label htmlFor="Department" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem' }}>
                                          Department
                                        </label>
                                      </div>
                                    </div>
                                
                                  <div className='d-flex justify-content-center'>
                                  <button
                                    style={{ backgroundColor: '#624DE3', color: 'white', borderRadius: '9999px', padding: '0.5rem 1rem', minWidth: '150px', display: 'block', border: 'none' }}
                                    type="submit"
                                    onClick={updatePersonal}
                                  >
                                    Save
                                    
                                  </button>
                                  </div>
                                </CForm>
                                <div className='d-flex w-100 flex-column gap-3 flex-md-row align-items-center align-items-md-top justify-content-md-center'>
                                  <div style={{ width: 'fit-content', borderRadius: '50%', padding: '8px' }}>
                                    {(items?.profilePicId || tempImgUrl) ? (
                                      <img
                                        alt={name}
                                        src={
                                          tempImgUrl ||
                                          `https://media.aumhum.com/images/prod/${items.profilePicId}`
                                        }
                                        style={{
                                          width: '200px',
                                          height: '200px',
                                          borderRadius: '50%',
                                          objectFit: 'cover',
                                          alignItems: 'justify',
                                          marginRight: 'auto',
                                          marginLeft: 'auto',
                                          margin: 'auto',
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          width: '200px',
                                          height: '200px',
                                          borderRadius: '50%',
                                          backgroundColor: '#C5CEFD',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          fontSize: '4rem',
                                          color: '#5B38A8',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {name?.[0]?.toUpperCase() || '?'}
                                      </div>
                                    )}
                                    <div style={{ width: '100%', padding: '0 16px', marginTop: '8px', paddingBottom: '8px', alignItems: 'center' }}>
                                      <input
                                        id="fileUpload"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleFileUpload}
                                      />
                                      <button
                                        type="button"
                                        disabled={uploadingPicture}
                                        onClick={() => document.getElementById('fileUpload')?.click()}
                                        style={{
                                          backgroundColor: 'white',
                                          width: '100%',
                                          padding: '0.5rem 1rem',
                                          borderRadius: '0.5rem',
                                          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                          color: 'black',
                                          fontWeight: 'bold',
                                          border: 'none',
                                          cursor: uploadingPicture ? 'not-allowed' : 'pointer',
                                          opacity: uploadingPicture ? 0.7 : 1,
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div style={{ flexDirection: 'row', gap: '0.5rem', alignItems: 'center' }}>
                                          {uploadingPicture ? (
                                            <CSpinner size="sm" />
                                          ) : (
                                            <span>
                                              <FaUpload />
                                            </span>
                                          )}
                                          {uploadingPicture ? 'Uploading...' : 'Upload'}
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </Disclosure.Panel>
                      </Transition>
                    </>
                  )}
                </Disclosure>
              </div>

              <div id="organization-details" style={{ width: '100%', borderBottom: '1px solid #e2e8f0', alignItems: 'justify' }}>
                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button style={{ backgroundColor: '#EBF1FF', display: 'flex', alignItems: 'justify', padding: '16px', borderRadius: '0.5rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', width: '100%', border: 'none' }}>
                        <CHeading3 style={{ color: '#5B38A8', flex: '1', display: 'flex' }}>
                          Organization Details
                        </CHeading3>
                        <ChevronDownIcon
                          className="bi bi-chevron-up" style={{ transform: open ? 'rotate(180deg)' : 'none', color: '#5B38A8', height: '40px', width: '40px' }}
                        />
                      </Disclosure.Button>
                      <Transition
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                      >
                        <Disclosure.Panel className="h-auto -mt-4">
                          <div style={{ backgroundColor: '#EBF1FF', darkBackgroundColor: '#1F2937', padding: '1rem', marginBottom: '2rem', borderBottomLeftRadius: '1rem', marginTop: '-0.25rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
                            {loading ? (
                              <CSpinner className={loading ? `block p-4 m-4` : `hidden`} />
                            ) : (
                              <div style={{ width: '100%' }}>
                                {edit ? (
                                  <CForm
                                    onSubmit={handleSubmit}
                                    style={{ display: 'flex', flexDirection: 'column', padding: '0 40px', gap: '20px' }}
                                  >
                                    <h6 style={{ color: '#2C384AF2' }}>Edit Company Name</h6>
                                    <div className='d-flex w-100 flex-column gap-3 flex-md-row'></div>
                                    <div className='w-100' style={{ width: '50%', position: 'relative' }}>
                                      <input
                                        id="companyName"
                                        name="companyName"
                                        type="text"
                                        style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}

                                        value={newCompany}
                                        onChange={(e) => setNewCompany(e.target.value)}
                                      />
                                      <label htmlFor="companyName" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: '#2C384AF2' }}>
                                        Company Name
                                      </label>
                                    
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                      <button
                                        onClick={updateCompanyName}
                                        style={{ backgroundColor: '#624DE3', color: 'white', borderRadius: '9999px', padding: '0.5rem 1rem', minWidth: '150px', display: 'block', border: 'none' }}
                                        type="button"
                                      >
                                        Save
                                      </button>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                      <h6 style={{ color: '#2C384AF2' }}>Edit Company Locations</h6>
                                      <div style={{ textAlign: 'right', paddingRight: '16px' }}>
                                        <button
                                          style={{ color: '#10B981', backgroundColor: 'transparent', fontWeight: 'bold', borderRadius: '9999px', border: '1px solid #EBF1FF', padding: '8px 16px' }}
                                          type="button"
                                          onClick={() => addFormFields()}
                                        >
                                          + Add more
                                        </button>
                                      </div>
                                    </div>
                                    {primary.map((element, index) => (
                                      <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <p style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '16px', color: 'black', fontWeight: 'bold', fontSize: '20px' }}>
                                          <span>
                                            <img src={arrow} alt="arrow" />
                                          </span>
                                          {element.city}&nbsp; Office &#8211;&nbsp;
                                          {element.country}
                                          <div style={{ marginLeft: '16px' }}>
                                            {index ? (
                                              <p
                                                type="button"
                                                style={{ color: '#EF4444', cursor: 'pointer', fontSize: '16px', marginTop: '12px' }}
                                                onClick={() => removeFormFields(index)}
                                              >
                                                - Remove this address
                                              </p>
                                            ) : null}
                                          </div>
                                        </p>




                                        <div className='d-flex w-100 flex-column gap-3 flex-md-row'>
                                          <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>

                                            <input
                                              id="companyName"
                                              name="companyName"
                                              type="text"
                                              style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                              value={element.companyName}
                                              onChange={(e) => handleChange(index, e)}
                                            />
                                            <label htmlFor="companyName" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }}>
                                              Branch Office Name
                                            </label>
                                          </div>

                                          <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                            <input
                                              id="address"
                                              name="address"
                                              type="text"
                                              style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                              value={element.address}
                                              onChange={(e) => handleChange(index, e)}
                                            />
                                            <label htmlFor="address" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                              Street Address
                                            </label>
                                          </div>
                                        </div>



                                        <div className='d-flex w-100 flex-column gap-3 flex-md-row'>
                                          <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                            <input
                                              id="city"
                                              name="city"
                                              type="text"
                                              style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                              value={element.city}
                                              onChange={(e) => handleChange(index, e)}
                                            />
                                            <label htmlFor="city" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                              City
                                            </label>
                                          </div>

                                          <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                            <input
                                              id="state"
                                              name="state"
                                              type="text"
                                              style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                              onChange={(e) => handleChange(index, e)}
                                            />
                                            <label htmlFor="state" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                              State
                                            </label>
                                          </div>
                                        </div>


                                        <div className='d-flex w-100 flex-column gap-3 flex-md-row'>
                                          <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                            <label htmlFor="Country" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                              Country
                                            </label>
                                            <select
                                              id="country"
                                              name="country"
                                              value={element.country}
                                              style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                              onChange={(e) => {
                                                handleChange(index, e)
                                                handleCountryCode(index, e)
                                              }}
                                            >
                                              {countryAndCode
                                                .sort((a, b) =>
                                                  a.name.common.localeCompare(b.name.common),
                                                )
                                                .map((country, index) => (
                                                  <option
                                                    key={index}
                                                    className="text-black"
                                                    style={{
                                                      backgroundColor: '#C5CEFD',
                                                    }}
                                                    value={country.name.common}
                                                  >
                                                    {country.name.common}
                                                  </option>
                                                ))}
                                            </select>
                                          </div>


                                          <div className='w-100' style={{ position: 'relative',padding:'0.1rem' }}>
                                            <input
                                              id="pincode"
                                              name="pincode"
                                              type="text"
                                              style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                              value={element.pincode}
                                              onChange={(e) => handleChange(index, e)}
                                            />
                                            <label htmlFor="Pincode" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                              Pincode
                                            </label>
                                          </div>
                                        </div>
                                      </div>

                                    ))}
                                    <div className='d-flex justify-content-center'>
                                      <button
                                        onClick={update}
                                        style={{ backgroundColor: '#624DE3', color: 'white', borderRadius: '9999px', padding: '0.5rem 1rem', minWidth: '150px', display: 'block', border: 'none' }}
                                        type="button"
                                      >
                                        Save
                                      </button>
                                    </div>
                                    <h6 className="dark:text-white">Edit Billing Details</h6>
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                      <div style={{ width: '100%', position: 'relative' }}>

                                        <input
                                          id="billingName"
                                          name="billingName"
                                          type="text"
                                          style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                          value={billingName}
                                          onChange={(e) => setBillingName(e.target.value)}
                                        />
                                        <label htmlFor="Billing name" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                          Billing Name
                                        </label>
                                      </div>
                                    </div>
                                    <div style={{ width: '100%', display: 'flex' }}>
                                      <div style={{ width: '100%', position: 'relative' }}>
                                        <input
                                          id="billingEmail"
                                          name="billingEmail"
                                          type="text"
                                          style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                          onChange={(e) => setBillingEmail(e.target.value)}
                                        />
                                        <label htmlFor="Billing Email" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                          Billing Email
                                        </label>
                                      </div>
                                    </div>
                                    <div style={{ width: '100%', display: 'flex' }}>
                                      <div style={{ width: '100%', position: 'relative' }}>
                                        <input
                                          id="billingName"
                                          name="billingName"
                                          type="text"
                                          style={{ borderColor: '#8496FF', backgroundColor: 'transparent', borderWidth: '2px', width: '100%', padding: '0.75rem', outline: 'none', borderRadius: '0.5rem', color: 'black', border: '2px solid #8496FF' }}
                                          value={vat}
                                          onChange={(e) => setVat(e.target.value)}
                                        />
                                        <label htmlFor="Billing Email" style={{ position: 'absolute', top: '-0.7rem', left: '10px', backgroundColor: '#EBF1FF', padding: '0 0.5rem', color: 'black' }} >
                                          GST Number
                                        </label>
                                      </div>
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                      <button
                                        onClick={updateBilling}
                                        style={{ backgroundColor: '#624DE3', color: 'white', borderRadius: '9999px', padding: '0.5rem 1rem', minWidth: '150px', display: 'block', border: 'none' }}
                                        type="button"
                                     >
                                        Save
                                      </button>
                                    </div>
                                  </CForm>
                                ) : (
                                  <div style={{ width: '100%', paddingLeft: '5px', paddingRight: '5px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginBottom: '4rem' }}>
                                      <button
                                        id="editButton"
                                        onClick={handleSubmit}
                                        style={{ backgroundColor: '#fff', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', borderRadius: '50%', padding: '0.5rem', border: 'none' }}
                                      >
                                        <span>
                                          <img src="edit.png" alt="edit" style={{ width: '30px', height: '30px' }} />
                                        </span>
                                      </button>
                                    </div>
                                    <p className="w-3/5 flex flex-row items-center dark:text-white gap-2 mt-4 font-black text-xl">
                                      <span>
                                        <img src={arrow} alt="arrow" />
                                      </span>
                                      Company Name {newCompany}
                                    </p>

                                    {primary.map((item) => {
                                      return (
                                        <>
                                          <p className="w-3/5 flex flex-row dark:text-white items-center gap-2 mt-4 font-black text-xl">
                                            <span>
                                              <img src={arrow} alt="arrow" />
                                            </span>
                                            {item.city}&nbsp; Office &#8211;&nbsp;{item.country}
                                          </p>
                                          {/* <p className="-mb-3 ml-4 bg-cardLight dark:bg-cardDark">
                                            Address
                                          </p> */}
                                          <div
                                            style={{ borderColor: '#8496FF', border: '2px solid #8496FF', borderRadius: '0.5rem' }}
                                            className="bg-transparent text-lg dark:text-white font-black border-2 w-3/5 p-4 outline-none rounded-lg"
                                          >
                                            <p>{newCompany}</p>
                                            <p>{item.address}</p>
                                            <p className="inline-block">
                                              {item.city}, &nbsp;
                                              {item.state}, &nbsp;
                                              {item.country}, &nbsp;
                                              {item.pincode}
                                            </p>
                                          </div>
                                        </>
                                      )
                                    })}

                                    <p className="w-3/5 flex flex-row dark:text-white items-center gap-2 mt-4 font-black text-xl">
                                      <span>
                                        <img src={arrow} alt="arrow" />
                                      </span>
                                      Billing&nbsp;details
                                    </p>

                                    <div
                                      style={{ border: '2px solid #8496FF', borderColor: '#8496FF', borderRadius: '0.5rem' }}
                                      className="bg-transparent dark:text-white text-lg font-black border-2 w-3/5 p-4 outline-none rounded-lg"
                                    >
                                      <p>{newCompany}</p>
                                      <p></p>
                                      <p>Billing Name&nbsp;: {billingName}</p>
                                      <p>Billing Email&nbsp;: {billingEmail}</p>
                                      <p>GST No.&nbsp;: {vat}</p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </Disclosure.Panel>
                      </Transition>
                    </>
                  )}
                </Disclosure>
              </div>

              {/* <div id="password-change" className="mb-10">
                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center py-4 justify-between rounded-t-xl shadow-xl bg-cardLight px-4 py-2 text-left text-sm font-medium text-textHeading dark:bg-cardDark dark:text-white">
                        <CHeading3 className="font-black text-textHeading dark:text-white">
                          Password
                        </CHeading3>
                        <ChevronDownIcon
                          className={`${
                            open ? 'rotate-180 transform' : ''
                          } h-10 w-10 text-textHeading dark:text-white`}
                        />
                      </Disclosure.Button>
                      <Transition
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                      >
                        <Disclosure.Panel className="h-auto -mt-1">
                          <div className="bg-cardLight dark:bg-cardDark p-4 mb-8 rounded-b-xl shadow-xl">
                            <CForm className="">
                              <div className="flex mx-auto flex-col px-10 gap-10">
                                <div
                                  style={{ borderColor: '#8496FF' }}
                                  className="w-2/5 label-floating flex flex-row justify-between border-2 w-full outline-none rounded-lg mx-auto relative appearance-none"
                                >
                                  <input
                                    id="oldPassword"
                                    type={passwordType}
                                    style={{ borderColor: '#8496FF', color: '#8496FF' }}
                                    className="bg-transparent w-full p-3 outline-none rounded-lg"
                                    value={oldPassword}
                                    onChange={(e) => setoldPassword(e.target.value)}
                                  />
                                  <button className="p-2" type="button" onClick={togglePassword}>
                                    {passwordType === 'password' ? (
                                      <i className="dark:text-white">
                                        <AiFillEyeInvisible />
                                      </i>
                                    ) : (
                                      <i className="dark:text-white">
                                        <AiFillEye />
                                      </i>
                                    )}
                                  </button>
                                  <label className="absolute block top-0 bg-cardLight left-2 dark:bg-cardDark dark:text-white">
                                    Current Password
                                  </label>
                                </div>
                                <div
                                  style={{ borderColor: '#8496FF', color: '#8496FF' }}
                                  className="w-2/5 label-floating flex flex-row justify-between border-2 w-full outline-none rounded-lg mx-auto relative appearance-none"
                                >
                                  <input
                                    id="newPassword"
                                    type={newPasswordType}
                                    style={{ borderColor: '#8496FF', color: '#8496FF' }}
                                    className="bg-transparent w-full p-3 outline-none rounded-lg"
                                    value={password}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                  />
                                  <button className="p-2" type="button" onClick={toggleNewPassword}>
                                    {newPasswordType === 'password' ? (
                                      <i className="dark:text-white">
                                        <AiFillEyeInvisible />
                                      </i>
                                    ) : (
                                      <i className="dark:text-white">
                                        <AiFillEye />
                                      </i>
                                    )}
                                  </button>
                                  <label className="absolute block top-0 bg-cardLight left-2 dark:bg-cardDark dark:text-white">
                                    New Password
                                  </label>
                                </div>
                                <div
                                  style={{ borderColor: '#8496FF', color: '#8496FF' }}
                                  className="w-2/5 label-floating flex flex-row justify-between border-2 w-full outline-none rounded-lg mx-auto relative appearance-none"
                                >
                                  <input
                                    id="companyName"
                                    type="password"
                                    className="bg-transparent w-full p-3 outline-none rounded-lg"
                                    value={confPassword}
                                    onChange={(e) => setConfPassword(e.target.value)}
                                  />
                                  <label className="absolute block top-0 bg-cardLight left-2 dark:bg-cardDark dark:text-white">
                                    Confirm Password
                                  </label>
                                </div>
                                <div className="-mt-4 my-8">
                                  <LoadingOverlay
                                    className="z-40 mb-4 text-blue-700 bg-blue-700"
                                    active={loading}
                                    spinner
                                    text=""
                                  />
                                  <div className={loading ? 'hidden' : 'block text-center'}>
                                    <button
                                      onClick={PasswordChange}
                                      id="saveButton"
                                      className="bg-buttonCol dark:bg-buttonColDark w-1/4 mx-auto rounded-full p-2 text-white"
                                      type="submit"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </CForm>
                          </div>
                        </Disclosure.Panel>
                      </Transition>
                    </>
                  )}
                </Disclosure>
              </div> */}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default UserProfile